/* ==========================================================================
   CP-BAG: behaviour for the drawstring bag product page and the size finder.
   Colour -> Size -> Fabric -> Closure -> Pack -> Quantity.
   No framework. Loaded (deferred) by snippets/cp-bag-assets.liquid; the guard
   below makes a second <script> of the same file a no-op.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__cpBagLoaded) return;
  window.__cpBagLoaded = true;

  var cache = new Map();

  /* ---------------------------------------------------------------- utils */
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  var FMT = "${{amount}}";
  function money(cents) {
    var v = (Math.round(cents) / 100);
    var m = FMT.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : "amount";
    var out;
    if (kind === "amount_no_decimals") out = Math.round(v).toLocaleString("en-US");
    else if (kind === "amount_with_comma_separator") out = v.toFixed(2).replace(".", ",");
    else out = v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return FMT.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function lbl(size) { return String(size).replace("x", "×"); }
  function packName(n) { return n === 1 ? "Single bag" : "Pack of " + n; }
  function plural(n, w) { return n + " " + w + (n === 1 ? "" : "s"); }

  /* ------------------------------------------- drawn to scale (gallery) */
  function drawBag(svg, w, h, hex) {
    if (!svg) return;
    var cw = 3.37, chh = 2.125, W = 520, H = 380, pad = 46, gap = 36;
    var sc = Math.min((W - 2 * pad - gap) / (w + cw), (H - 2 * pad - 10) / Math.max(h, chh));
    var bw = w * sc, bh = h * sc, cardW = cw * sc, cardH = chh * sc;
    var x0 = (W - (bw + gap + cardW)) / 2, base = H - pad, by = base - bh, cx = x0 + bw + gap, cy = base - cardH;
    var ink = "#1E1E1E", stone = "rgba(51,51,51,0.7)", ch1 = Math.min(14, bh * 0.12);
    var fill = hex || "#F4F0EA";
    svg.innerHTML =
      '<title>' + lbl(w + "x" + h) + ' inch bag drawn to scale next to a credit card</title>' +
      '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="#FFFFFF"/>' +
      '<rect x="' + x0 + '" y="' + by + '" width="' + bw + '" height="' + bh + '" rx="3" fill="' + fill + '" stroke="' + ink + '" stroke-width="1.5"/>' +
      '<line x1="' + x0 + '" y1="' + (by + ch1) + '" x2="' + (x0 + bw) + '" y2="' + (by + ch1) + '" stroke="' + ink + '" stroke-width="1" stroke-dasharray="3 3"/>' +
      '<path d="M' + (x0 + bw * 0.3) + ' ' + (by + ch1) + ' q -6 -22 -16 -30" fill="none" stroke="' + ink + '" stroke-width="1.3"/>' +
      '<path d="M' + (x0 + bw * 0.7) + ' ' + (by + ch1) + ' q 6 -22 16 -30" fill="none" stroke="' + ink + '" stroke-width="1.3"/>' +
      '<g stroke="' + ink + '" stroke-width="1"><line x1="' + x0 + '" y1="' + (base + 16) + '" x2="' + (x0 + bw) + '" y2="' + (base + 16) + '"/><line x1="' + x0 + '" y1="' + (base + 10) + '" x2="' + x0 + '" y2="' + (base + 22) + '"/><line x1="' + (x0 + bw) + '" y1="' + (base + 10) + '" x2="' + (x0 + bw) + '" y2="' + (base + 22) + '"/></g>' +
      '<text x="' + (x0 + bw / 2) + '" y="' + (base + 36) + '" text-anchor="middle" font-family="Poppins, sans-serif" font-size="13" font-weight="500" fill="' + ink + '">' + w + ' IN</text>' +
      '<g stroke="' + ink + '" stroke-width="1"><line x1="' + (x0 - 16) + '" y1="' + by + '" x2="' + (x0 - 16) + '" y2="' + base + '"/><line x1="' + (x0 - 22) + '" y1="' + by + '" x2="' + (x0 - 10) + '" y2="' + by + '"/><line x1="' + (x0 - 22) + '" y1="' + base + '" x2="' + (x0 - 10) + '" y2="' + base + '"/></g>' +
      '<text x="' + (x0 - 24) + '" y="' + (by + bh / 2) + '" text-anchor="middle" font-family="Poppins, sans-serif" font-size="13" font-weight="500" fill="' + ink + '" transform="rotate(-90 ' + (x0 - 24) + ' ' + (by + bh / 2) + ')">' + h + ' IN</text>' +
      '<rect x="' + cx + '" y="' + cy + '" width="' + cardW + '" height="' + cardH + '" rx="' + Math.max(2, cardW * 0.04) + '" fill="none" stroke="' + stone + '" stroke-width="1.2" stroke-dasharray="4 3"/>' +
      '<text x="' + (cx + cardW / 2) + '" y="' + (base + 36) + '" text-anchor="middle" font-family="Poppins, sans-serif" font-size="11" fill="' + stone + '">CREDIT CARD</text>';
  }

  /* ------------------------------ cheapest mix of packs for N bags (DP) */
  function bestCombo(packs, N) {
    /* packs: [{n, price, id}] ; returns {exact, best, singles} */
    var M = N + 500, INF = 1e15;
    var cost = new Array(M + 1).fill(INF), pick = new Array(M + 1).fill(-1);
    cost[0] = 0;
    for (var b = 1; b <= M; b++) {
      for (var i = 0; i < packs.length; i++) {
        var n = packs[i].n;
        if (n <= b && cost[b - n] + packs[i].price < cost[b]) { cost[b] = cost[b - n] + packs[i].price; pick[b] = i; }
      }
    }
    function build(b) { var c = []; var map = {}; while (b > 0 && pick[b] >= 0) { var p = packs[pick[b]]; map[p.id] = map[p.id] || { p: p, q: 0 }; map[p.id].q++; b -= p.n; } Object.keys(map).forEach(function (k) { c.push(map[k]); }); c.sort(function (a, z) { return z.p.n - a.p.n; }); return c; }
    var best = N;
    for (var k = N; k <= M; k++) if (cost[k] < cost[best] - 0.5) best = k;
    var single = packs.filter(function (p) { return p.n === 1; })[0];
    return {
      exact: cost[N] < INF ? { bags: N, cost: cost[N], combo: build(N) } : null,
      best: cost[best] < INF ? { bags: best, cost: cost[best], combo: build(best) } : null,
      singles: single ? single.price * N : null
    };
  }
  function comboText(c) { return c.map(function (x) { return x.q + " × " + (x.p.n === 1 ? "single" : "pack of " + x.p.n); }).join(" + "); }

  /* ================================================== PRODUCT SECTION === */
  function initProduct(root, carry) {
    var jsonEl = qs("[data-cpb-json]", root);
    if (!jsonEl) return;
    var D;
    try { D = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (D.moneyFormat) FMT = D.moneyFormat.replace(/<[^>]*>/g, "");
    var sectionId = root.getAttribute("data-section");
    var form = qs("[data-form]", root);
    var packsEl = qs("[data-packs]", root);
    var qtyEl = qs("[data-qty]", root);
    var addBtn = qs("[data-add]", root);
    var errEl = qs("[data-err]", root);
    var sticky = qs("[data-sticky]", root);
    var toastEl = qs("[data-toast]", root);
    var exactIn = qs("[data-exact-input]", root);
    var exactOut = qs("[data-exact-result]", root);
    var exactClear = qs("[data-exact-clear]", root);
    var fabricInputs = qsa('[data-step="fabric"] input', root);
    var closureInputs = qsa('[data-step="closure"] input', root);

    var checkedF = fabricInputs.filter(function (i) { return i.checked; })[0];
    var checkedC = closureInputs.filter(function (i) { return i.checked; })[0];
    var checkedP = qs('[data-packs] input:checked', root);
    var startV = checkedP ? byId(+checkedP.value) : D.variants[0];
    var S = {
      f: checkedF ? checkedF.value : startV.f,
      c: checkedC ? checkedC.value : startV.c,
      n: startV ? startV.n : 100,
      qty: 1,
      combo: null,
      busy: false
    };

    function byId(id) { return D.variants.filter(function (v) { return v.id === id; })[0]; }
    function packsFor(f, c) { return D.variants.filter(function (v) { return v.f === f && v.c === c; }).sort(function (a, b) { return a.n - b.n; }); }
    function closuresFor(f) { var s = []; D.variants.forEach(function (v) { if (v.f === f && s.indexOf(v.c) < 0) s.push(v.c); }); return s; }
    function current() { return D.variants.filter(function (v) { return v.f === S.f && v.c === S.c && v.n === S.n; })[0]; }

    /* Choose the nearest valid combination for a wished-for fabric/closure/pack. */
    /* CP-OOS: only in-stock combinations are chosen automatically; a size that is sold out
       through and through falls back to every variant so the page still renders. */
    function settle(prefF, prefC, prefN) {
      var pool = D.variants.filter(function (v) { return v.a; });
      if (!pool.length) pool = D.variants;
      var fabrics = []; pool.forEach(function (v) { if (fabrics.indexOf(v.f) < 0) fabrics.push(v.f); });
      S.f = fabrics.indexOf(prefF) >= 0 ? prefF : (fabrics.filter(function (f) { return /145/.test(f); })[0] || S.f);
      if (fabrics.indexOf(S.f) < 0) S.f = fabrics[0];
      var cl = []; pool.forEach(function (v) { if (v.f === S.f && cl.indexOf(v.c) < 0) cl.push(v.c); });
      S.c = cl.indexOf(prefC) >= 0 ? prefC : (cl.filter(function (c) { return /Double/.test(c); })[0] || cl[0]);
      var ps = pool.filter(function (v) { return v.f === S.f && v.c === S.c; }).map(function (v) { return v.n; });
      if (ps.indexOf(prefN) >= 0) S.n = prefN;
      else if (ps.indexOf(100) >= 0) S.n = 100;
      else S.n = ps.reduce(function (a, n) { return Math.abs(n - prefN) < Math.abs(a - prefN) ? n : a; }, ps[0]);
    }

    function renderClosures() {
      var cl = closuresFor(S.f).filter(function (c) { return D.variants.some(function (v) { return v.f === S.f && v.c === c && v.a; }); });
      if (!cl.length) cl = closuresFor(S.f);
      closureInputs.forEach(function (i) {
        i.disabled = cl.indexOf(i.value) < 0;
        i.checked = i.value === S.c;
      });
      var aside = qs("[data-closure-aside]", root);
      if (aside) aside.textContent = cl.length === 1 ? (/Single/.test(cl[0]) ? "Single only in this fabric" : "Double only in this fabric") : "Both closures in this fabric";
      fabricInputs.forEach(function (i) { i.checked = i.value === S.f; });
    }

    function renderPacks() {
      var list = packsFor(S.f, S.c);
      var single = list.filter(function (v) { return v.n === 1; })[0];
      packsEl.innerHTML = list.map(function (v) {
        var per = Math.round(v.price / v.n);
        var off = single ? Math.round((1 - (v.price / v.n) / single.price) * 100) : 0;
        var sub = !v.a ? "Sold out in this fabric" : v.n === 1
          ? "<b>" + money(v.price) + "</b> · try the size"
          : "<b>" + money(per) + "</b> a bag" + (single && off > 0 ? " · " + off + "% less per bag" : "");
        var tag = v.n === 100 ? ' <span class="cpb-tag font-sans text-[10.5px] font-semibold tracking-[.06em] uppercase bg-brand-primary text-[#1E1E1E] pt-[.14rem] pr-[.45rem] pb-[.14rem] pl-[.7rem] [clip-path:polygon(6px_0,100%_0,100%_100%,6px_100%,0_50%)] whitespace-nowrap leading-[1.4] [.cpb-opt_&]:absolute [.cpb-opt_&]:top-[8px] [.cpb-opt_&]:right-0 [.cpb-ladder_tr.hl_td:first-child_&]:ml-[8px] [.cpb-steps_li.is-key_&]:absolute [.cpb-steps_li.is-key_&]:top-[20px] [.cpb-steps_li.is-key_&]:right-0">Most ordered</span>' : "";
        return '<label class="cpb-pack relative [display:grid] grid-cols-[auto_1fr_auto] items-center gap-[.8rem] bg-white border border-[#1E1E1E]/14 rounded-[10px] py-[.7rem] px-[.9rem] cursor-pointer [transition:border-color_.15s] [&:hover]:border-[#333333]/70 [&_input]:absolute [&_input]:opacity-0 [&_input]:pointer-events-none [&_.dot]:w-[18px] [&_.dot]:h-[18px] [&_.dot]:border-[1.5px] [&_.dot]:border-[#1E1E1E] [&_.dot]:rounded-[50%] [&_.dot]:[display:grid] [&_.dot]:place-items-center [&_input:checked~.dot]:after:w-[9px] [&_input:checked~.dot]:after:h-[9px] [&_input:checked~.dot]:after:rounded-[50%] [&_input:checked~.dot]:after:bg-[#1E1E1E] [&:has(input:checked)]:border-[2px] [&:has(input:checked)]:border-[#1E1E1E] [&:has(input:checked)]:py-[calc(.7rem_-_1px)] [&:has(input:checked)]:px-[calc(.9rem_-_1px)] [&:has(input:focus-visible)]:[outline:2px_solid_#1E1E1E] [&:has(input:focus-visible)]:outline-offset-[2px] [.cpb-packs.is-combo_&:has(input:checked)]:[border:1px_dashed_rgba(51,51,51,0.7)] [.cpb-packs.is-combo_&:has(input:checked)]:py-[.7rem] [.cpb-packs.is-combo_&:has(input:checked)]:px-[.9rem] [&_.name]:flex [&_.name]:flex-col [&_.name]:gap-[.1rem] [&_.name]:min-w-0 [&_.nm]:font-semibold [&_.nm]:flex [&_.nm]:gap-2 [&_.nm]:items-center [&_.nm]:[flex-wrap:wrap] [&_.per]:font-sans [&_.per]:text-[12.5px] [&_.per]:text-[#333333]/70 [&_.per_b]:text-[#1E1E1E] [&_.per_b]:font-medium [&_.tot]:font-sans [&_.tot]:text-[1.05rem] [&_.tot]:font-medium [&_.tot]:text-right [&_.tot]:tabular-nums [&_.tot_s]:block [&_.tot_s]:text-[11.5px] [&_.tot_s]:text-[#333333]/70 [&_.tot_s]:font-normal [@media(max-width:640px)]:gap-[.6rem] [@media(max-width:640px)]:py-[.65rem] [@media(max-width:640px)]:px-3 [@media(max-width:640px)]:[&:has(input:checked)]:py-[calc(.65rem_-_1px)] [@media(max-width:640px)]:[&:has(input:checked)]:px-[calc(.75rem_-_1px)]"><input type="radio" name="id" value="' + v.id + '"' + (v.n === S.n ? " checked" : "") + (v.a ? "" : " disabled") + '>' +
          '<span class="dot" aria-hidden="true"></span><span class="name"><span class="nm">' + packName(v.n) + tag + '</span><span class="per">' + sub + '</span></span>' +
          '<span class="tot">' + money(v.price) + (v.cmp > v.price ? "<s>" + money(v.cmp) + "</s>" : "") + '</span></label>';
      }).join("");
      packsEl.classList.toggle("is-combo", !!S.combo);
    }

    function renderExact() {
      if (!exactIn) return;
      var v = parseInt(exactIn.value, 10);
      if (exactClear) exactClear.hidden = !exactIn.value;
      if (!v || v < 1) { S.combo = null; exactOut.innerHTML = ""; return; }
      var N = Math.min(v, 5000);
      var packs = packsFor(S.f, S.c).filter(function (p) { return p.a; });
      var r = bestCombo(packs, N);
      var useBest = r.best && r.exact && r.best.bags > N;
      var pick = useBest ? r.best : (r.exact || r.best);
      if (!pick) { S.combo = null; exactOut.innerHTML = ""; return; }
      S.combo = pick;
      var html = '<div class="line">' + comboText(pick.combo) + '</div>' +
        '<div><b class="mono [.cpb_&]:font-sans">' + money(pick.cost) + '</b> for ' + pick.bags + ' bags · <span class="mono [.cpb_&]:font-sans">' + money(pick.cost / pick.bags) + '</span> a bag</div>';
      if (useBest) html += '<div class="anchor">That\'s ' + (pick.bags - N) + ' more bags than you asked for, and <span class="mono [.cpb_&]:font-sans">' + money(r.exact.cost - pick.cost) + '</span> less than exactly ' + N + '.</div>';
      if (N > 1 && r.singles) html += '<div class="anchor">As ' + N + ' single bags: <s>' + money(r.singles) + '</s></div>';
      exactOut.innerHTML = html;
    }

    function update() {
      var v = current();
      var sub = qs("[data-sub]", root);
      if (sub) sub.textContent = S.f.replace(", ", " · ") + " · " + S.c.charAt(0) + S.c.slice(1).toLowerCase();
      var fName = S.f.split(",")[0], fW = /GSM/.test(S.f) ? S.f.split(", ").pop() : "Not rated";
      setSpec("fabric", fName); setSpec("weight", fW);
      setSpec("closure", S.c.charAt(0) + S.c.slice(1).toLowerCase());
      setSpec("sku", v ? v.sku : "");

      var qtyRow = qs("[data-qtyrow]", root);
      if (qtyRow) qtyRow.classList.toggle("is-off", !!S.combo);
      if (qtyEl) qtyEl.disabled = !!S.combo;
      qsa("[data-q]", root).forEach(function (b) { b.disabled = !!S.combo || (b.getAttribute("data-q") === "-1" && S.qty <= 1); });
      packsEl.classList.toggle("is-combo", !!S.combo);

      var bags, cost, desc;
      if (S.combo) { bags = S.combo.bags; cost = S.combo.cost; desc = comboText(S.combo.combo); }
      else if (v) { bags = v.n * S.qty; cost = v.price * S.qty; desc = (S.qty > 1 ? S.qty + " × " : "") + packName(v.n).replace("Pack", S.qty > 1 ? "pack" : "Pack"); }
      setSpec("pack", S.combo ? desc : (v ? packName(v.n) : ""));

      var sum = qs("[data-qtysum]", root);
      if (sum && v) {
        sum.innerHTML = S.combo ? "Using the exact-number mix below"
          : "<b>" + plural(bags, "bag") + "</b> · " + money(Math.round(cost / bags)) + " a bag";
      }
      var available = S.combo ? true : !!(v && v.a);
      if (addBtn) {
        addBtn.disabled = !available || S.busy;
        if (!S.busy) addBtn.innerHTML = available ? "Add " + plural(bags, "bag") + ' — <span class="m">' + money(cost) + "</span>" : "Sold out";
      }
      var st = qs("[data-st-total]", root), sd = qs("[data-st-desc]", root);
      if (st) st.textContent = money(cost || 0);
      if (sd) sd.textContent = lbl(D.size) + " · " + desc;
      var tryBtn = qs("[data-try]", root);
      var single = packsFor(S.f, S.c).filter(function (x) { return x.n === 1; })[0];
      if (tryBtn) { tryBtn.hidden = !single; if (single) tryBtn.innerHTML = 'or try one for <span class="mono [.cpb_&]:font-sans">' + money(single.price) + "</span>"; }

      /* keep ?variant= in the address so a shared or refreshed link opens this spec */
      if (v && !S.combo && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(history.state, "", u.toString()); } catch (e) {}
      }
      /* the natural fabric photos (variant images) follow the fabric choice */
      if (v && v.media) showSlide(String(v.media), true);
    }
    function setSpec(k, t) { var el = qs('[data-spec="' + k + '"]', root); if (el) el.textContent = t; }

    /* ---- gallery */
    var gal = qs("[data-gal]", root);
    function showSlide(key, fromVariant) {
      if (!gal) return;
      var slide = qs('[data-slide="' + key + '"]', gal);
      if (!slide) return;
      if (fromVariant && root.getAttribute("data-lead") === "drawing" && qs('[data-slide="draw"]', gal).classList.contains("is-on") && !S.userPhoto) return;
      qsa(".cpb-slide", gal).forEach(function (s) { s.classList.toggle("is-on", s === slide); });
      qsa("[data-to]", gal).forEach(function (t) { t.setAttribute("aria-selected", t.getAttribute("data-to") === key ? "true" : "false"); });
    }
    if (gal) {
      gal.addEventListener("click", function (e) {
        var t = e.target.closest("[data-to]");
        if (!t) return;
        S.userPhoto = t.getAttribute("data-to") !== "draw";
        showSlide(t.getAttribute("data-to"));
      });
      drawBag(qs("[data-draw]", gal), D.w, D.h, D.hex);
    }

    /* ---- toast */
    function toast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add("show");
      clearTimeout(toastEl._h);
      toastEl._h = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
    }

    /* ---- events: fabric / closure / pack / qty */
    root.addEventListener("change", function (e) {
      var t = e.target;
      if (fabricInputs.indexOf(t) >= 0) {
        var prevC = S.c;
        settle(t.value, S.c, S.n);
        if (S.c !== prevC) toast(S.c.charAt(0) + S.c.slice(1).toLowerCase() + " selected: it's the only closure in this fabric.");
        renderClosures(); renderPacks(); renderExact(); update();
      } else if (closureInputs.indexOf(t) >= 0) {
        settle(S.f, t.value, S.n);
        renderClosures(); renderPacks(); renderExact(); update();
      } else if (t.name === "id" && packsEl.contains(t)) {
        S.n = byId(+t.value).n;
        clearExact(); update();
      } else if (t === qtyEl) {
        S.qty = Math.max(1, Math.min(999, parseInt(qtyEl.value, 10) || 1));
        qtyEl.value = S.qty; update();
      }
    });
    if (qtyEl) qtyEl.addEventListener("input", function () {
      var n = parseInt(qtyEl.value, 10);
      if (n >= 1) { S.qty = Math.min(999, n); update(); }
    });
    root.addEventListener("click", function (e) {
      var q = e.target.closest("[data-q]");
      if (q && root.contains(q)) {
        S.qty = Math.max(1, Math.min(999, S.qty + parseInt(q.getAttribute("data-q"), 10)));
        qtyEl.value = S.qty; update(); return;
      }
      if (e.target.closest("[data-try]")) {
        settle(S.f, S.c, 1); S.qty = 1; qtyEl.value = 1; clearExact();
        renderPacks(); update();
        toast("Single bag selected. Try the size before you buy a pack.");
        return;
      }
      if (e.target.closest("[data-exact-clear]")) { clearExact(); update(); exactIn.focus(); return; }
      var more = e.target.closest("[data-more]");
      if (more) {
        var all = qs("[data-all]", root);
        all.hidden = !all.hidden;
        more.setAttribute("aria-expanded", String(!all.hidden));
        more.textContent = all.hidden ? "All " + qsa("[data-all] [data-size]", root).length + " sizes" : "Fewer sizes";
        return;
      }
      var nav = e.target.closest("[data-nav]");
      if (nav && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        if (nav.getAttribute("aria-current") === "true") { e.preventDefault(); return; }
        e.preventDefault();
        go(nav.getAttribute("href"), null, nav.getAttribute("data-want-f"));
        return;
      }
      if (e.target.closest("[data-st-add]")) { form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click(); }
    });
    function clearExact() { if (exactIn) { exactIn.value = ""; } S.combo = null; if (exactOut) exactOut.innerHTML = ""; if (exactClear) exactClear.hidden = true; packsEl.classList.remove("is-combo"); }
    if (exactIn) exactIn.addEventListener("input", function () { renderExact(); update(); });

    /* ---- prefetch sibling sections on intent, so the swap feels instant */
    function sectionUrl(href) {
      var u = new URL(href, location.origin);
      u.searchParams.delete("variant");
      u.searchParams.set("section_id", sectionId);
      return u.toString();
    }
    function fetchSection(href) {
      var key = sectionUrl(href);
      if (!cache.has(key)) {
        cache.set(key, fetch(key, { credentials: "same-origin" }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        }).catch(function (err) { cache.delete(key); throw err; }));
      }
      return cache.get(key);
    }
    root.addEventListener("pointerenter", function (e) {
      var nav = e.target.closest && e.target.closest("[data-nav]");
      if (nav && nav.getAttribute("aria-current") !== "true") fetchSection(nav.getAttribute("href")).catch(function () {});
    }, true);
    root.addEventListener("touchstart", function (e) {
      var nav = e.target.closest && e.target.closest("[data-nav]");
      if (nav) fetchSection(nav.getAttribute("href")).catch(function () {});
    }, { passive: true, capture: true });

    /* ---- move to a sibling (colour or size) in place, keeping the spec */
    function go(href, carryOver, wantF) {
      var keep = carryOver || { f: S.f, c: S.c, n: S.n, qty: S.qty, exact: exactIn ? exactIn.value : "", allOpen: !qs("[data-all]", root) || !qs("[data-all]", root).hidden };
      if (wantF) keep.f = wantF;
      root.classList.add("is-loading");
      fetchSection(href).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = qs("[data-cpb-product]", doc);
        if (!fresh) throw new Error("no section");
        root.replaceWith(fresh);
        var url = new URL(href, location.origin);
        history.pushState({ cpb: 1 }, "", url.pathname);
        var h1 = qs(".cpb-h1", fresh);
        if (h1) document.title = h1.textContent.replace(/\s+/g, " ").trim().replace(/^./, function (c) { return c.toUpperCase(); }) + " | Cotton Pouch";
        initProduct(fresh, keep);
      }).catch(function () { location.href = href; });
    }
    root.__cpbGo = go;

    /* ---- add to cart (uses the theme's drawer when present) */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (S.busy) return;
      var v = current();
      var items = S.combo
        ? S.combo.combo.map(function (x) { return { id: x.p.id, quantity: x.q }; })
        : (v ? [{ id: v.id, quantity: S.qty }] : []);
      if (!items.length) return;
      S.busy = true;
      if (errEl) errEl.hidden = true;
      addBtn.disabled = true;
      addBtn.setAttribute("aria-busy", "true");
      addBtn.textContent = "Adding…";
      var body = { items: items };
      var req = window.cpAddToCart
        ? window.cpAddToCart(body)
        : fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || "We could not add that to your cart."); location.href = "/cart"; return d; }); });
      req.then(function () {
        S.busy = false;
        addBtn.removeAttribute("aria-busy");
        addBtn.textContent = "Added ✓";
        setTimeout(update, 1600);
      }).catch(function (err) {
        S.busy = false;
        addBtn.removeAttribute("aria-busy");
        update();
        if (errEl) { errEl.textContent = err.message || "Something went wrong. Please try again."; errEl.hidden = false; }
      });
    });

    /* ---- sticky quick-add: only while the main button is off screen */
    if (sticky && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { sticky.classList.toggle("show", !en.isIntersecting); });
      });
      io.observe(addBtn);
    }

    /* ---- first paint: apply what the buyer had chosen on the previous size/colour */
    if (carry) {
      settle(carry.f, carry.c, carry.n);
      if (carry.f && S.f !== carry.f && D.variants.some(function (v) { return v.f === carry.f; })) {
        setTimeout(function () { toast(carry.f.replace(", ", " ") + " is sold out in " + lbl(D.size) + ", so we picked " + S.f.replace(", ", " ") + "."); }, 60);
      }
      S.qty = carry.qty || 1;
      if (qtyEl) qtyEl.value = S.qty;
      renderClosures(); renderPacks();
      if (carry.exact && exactIn) { qs("[data-exact]", root).open = true; exactIn.value = carry.exact; renderExact(); }
      if (carry.allOpen) {
        var all = qs("[data-all]", root), more = qs("[data-more]", root);
        if (all && more && all.hidden) { all.hidden = false; more.setAttribute("aria-expanded", "true"); more.textContent = "Fewer sizes"; }
      }
    } else {
      renderClosures();
    }
    update();

    window.cpBagCurrent = { root: root, data: D, go: go };
    document.dispatchEvent(new CustomEvent("cp:bag-change", { detail: { data: D, go: go } }));
  }

  window.addEventListener("popstate", function (e) { if (e.state && e.state.cpb) location.reload(); });
  /* the first entry also needs a marker so Back from a swapped size reloads it */
  try { if (!history.state) history.replaceState({ cpb: 1 }, "", location.href); } catch (e) {}

  /* ===================================================== SIZE FINDER === */
  function initFinder(root) {
    var cfgEl = qs("[data-finder-json]", root);
    if (!cfgEl) return;
    var C;
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var uses = C.uses || [];
    if (!uses.length) return;
    var cur = uses[0].key;
    uses.forEach(function (u) { if (u.default) cur = u.key; });

    function drawScale(d) {
      var g = qs("[data-scale-g]", root), svg = qs("[data-scale-svg]", root);
      if (!g || !svg) return;
      var FW = Math.max(8, Math.ceil(d.w + 3.5)), FH = Math.ceil(FW * 19 / 15);
      if (FH < d.h + 3.2) FH = Math.ceil(d.h + 3.2);
      svg.setAttribute("viewBox", "0 0 " + FW + " " + FH);
      var s = "", x, y;
      for (x = 0; x <= FW; x++) s += '<line x1="' + x + '" y1="0" x2="' + x + '" y2="' + FH + '" stroke="rgba(30,30,30,0.08)" stroke-width=".03"/>';
      for (y = 0; y <= FH; y++) s += '<line x1="0" y1="' + y + '" x2="' + FW + '" y2="' + y + '" stroke="rgba(30,30,30,0.08)" stroke-width=".03"/>';
      var bx = (FW - d.w) / 2, by = FH - 1.2 - d.h, top = Math.min(.9, d.h * .13);
      s += '<rect x="' + bx + '" y="' + by + '" width="' + d.w + '" height="' + d.h + '" fill="' + (d.hex || "#F4F0EA") + '" stroke="#1E1E1E" stroke-width=".07"/>';
      s += '<line x1="' + bx + '" y1="' + (by + top) + '" x2="' + (bx + d.w) + '" y2="' + (by + top) + '" stroke="#1E1E1E" stroke-width=".04" stroke-dasharray=".2 .15"/>';
      var cy = by + top / 2;
      s += '<path d="M' + (bx + d.w - .05) + ' ' + cy + ' q .6 ' + (d.h * .25) + ' .15 ' + (d.h * .42) + '" fill="none" stroke="#1E1E1E" stroke-width=".05"/>';
      s += '<path d="M' + (bx + .05) + ' ' + cy + ' q -.6 ' + (d.h * .25) + ' -.15 ' + (d.h * .42) + '" fill="none" stroke="#1E1E1E" stroke-width=".05"/>';
      var p = d.prod, px = bx + (d.w - p.w) / 2, py = by + d.h - p.h - Math.min(.4, d.h * .08);
      s += '<rect x="' + px + '" y="' + py + '" width="' + p.w + '" height="' + p.h + '" rx="' + (p.r || .2) + '" fill="#E7713B" opacity=".92"/>';
      var fs = Math.max(.34, Math.min(.6, p.w / 6));
      s += '<text x="' + (px + p.w / 2) + '" y="' + (py + p.h / 2 + fs * .35) + '" text-anchor="middle" font-family="Poppins,sans-serif" font-size="' + fs + '" fill="#1E1E1E">' + esc(p.t) + "</text>";
      var ty = by - .55;
      s += '<line x1="' + bx + '" y1="' + ty + '" x2="' + (bx + d.w) + '" y2="' + ty + '" stroke="#1E1E1E" stroke-width=".04"/>';
      s += '<line x1="' + bx + '" y1="' + (ty - .18) + '" x2="' + bx + '" y2="' + (ty + .18) + '" stroke="#1E1E1E" stroke-width=".04"/><line x1="' + (bx + d.w) + '" y1="' + (ty - .18) + '" x2="' + (bx + d.w) + '" y2="' + (ty + .18) + '" stroke="#1E1E1E" stroke-width=".04"/>';
      s += '<text x="' + (bx + d.w / 2) + '" y="' + (ty - .3) + '" text-anchor="middle" font-family="Poppins,sans-serif" font-size=".55" font-weight="600" fill="#1E1E1E">' + d.w + " in</text>";
      var tx = bx + d.w + .55;
      s += '<line x1="' + tx + '" y1="' + by + '" x2="' + tx + '" y2="' + (by + d.h) + '" stroke="#1E1E1E" stroke-width=".04"/>';
      s += '<line x1="' + (tx - .18) + '" y1="' + by + '" x2="' + (tx + .18) + '" y2="' + by + '" stroke="#1E1E1E" stroke-width=".04"/><line x1="' + (tx - .18) + '" y1="' + (by + d.h) + '" x2="' + (tx + .18) + '" y2="' + (by + d.h) + '" stroke="#1E1E1E" stroke-width=".04"/>';
      s += '<text x="' + (tx + .3) + '" y="' + (by + d.h / 2) + '" font-family="Poppins,sans-serif" font-size=".55" font-weight="600" fill="#1E1E1E" transform="rotate(90 ' + (tx + .3) + " " + (by + d.h / 2) + ')" text-anchor="middle">' + d.h + " in</text>";
      var ry = FH - .55;
      s += '<line x1="1" y1="' + ry + '" x2="' + (FW - 1) + '" y2="' + ry + '" stroke="rgba(51,51,51,0.7)" stroke-width=".03"/>';
      for (var i = 0; i <= FW - 2; i++) s += '<line x1="' + (1 + i) + '" y1="' + (ry - (i % 6 === 0 ? .3 : .15)) + '" x2="' + (1 + i) + '" y2="' + ry + '" stroke="rgba(51,51,51,0.7)" stroke-width=".03"/>';
      for (var L = 0; L <= FW - 2; L += (FW > 12 ? 6 : 2)) s += '<text x="' + (1 + L) + '" y="' + (FH - .1) + '" font-family="Poppins,sans-serif" font-size="' + (FW / 40) + '" fill="rgba(51,51,51,0.7)" text-anchor="' + (L ? "middle" : "start") + '">' + L + (L ? " in" : "") + "</text>";
      g.innerHTML = s;
      var t = qs("[data-scale-title]", root);
      if (t) t.textContent = "A " + d.w + "×" + d.h + " inch bag drawn to scale with a " + p.t + " inside";
    }

    function rangeEntry(colour, size) {
      var P = window.cpBagCurrent && window.cpBagCurrent.data;
      if (!P) return null;
      var r = null;
      P.range.forEach(function (e) { if (e[0] === colour && e[1] === size) r = e; });
      return r;
    }

    function render() {
      var u = uses.filter(function (x) { return x.key === cur; })[0];
      if (!u) return;
      var P = window.cpBagCurrent && window.cpBagCurrent.data;
      var colour = P ? P.colour : "natural", colourLabel = P ? P.colourLabel : "Natural";
      var size = u.w + "x" + u.h;
      var e = rangeEntry(colour, size);
      var inColour = !!e;
      qsa("[data-use]", root).forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-use") === cur ? "true" : "false"); });
      set("[data-res-for]", "Best fit for " + u.label);
      var rs = qs("[data-res-size]", root);
      if (rs) rs.innerHTML = lbl(size) + " <small>in · " + esc(inColour ? colourLabel.toLowerCase() : "natural") + "</small>";
      set("[data-res-fit]", u.fit);
      set("[data-res-also]", (inColour || !P) ? u.also : ("Not made in " + colourLabel.toLowerCase() + " at this size, so this is the natural bag. " + u.also));

      /* photo from the theme editor if there is one, else the drawing */
      var img = qs("[data-scale-img]", root), svg = qs("[data-scale-svg]", root), cap = qs("[data-scale-cap]", root);
      if (img && u.img) { img.src = u.img; img.alt = "The " + lbl(size) + " in bag with " + u.prod.t; img.hidden = false; svg.hidden = true; if (cap) cap.textContent = "Photo · " + lbl(size) + " in bag"; }
      else { if (img) img.hidden = true; if (svg) svg.hidden = false; drawScale({ w: u.w, h: u.h, prod: u.prod, hex: P && inColour ? P.hex : null }); if (cap) cap.textContent = "Drawn to scale · grid = 1 inch"; }

      /* price ladder: live prices for this colour when the product page provides them */
      var body = qs("[data-ladder]", root), table = qs("[data-ladder-table]", root);
      var entry = e || rangeEntry("natural", size);
      var ns = [1, 25, 50, 100, 500], rows = "";
      if (entry && entry[3]) {
        entry[3].forEach(function (p, i) {
          if (p == null) return;
          var n = ns[i];
          rows += "<tr" + (n === 100 ? ' class="hl"' : "") + "><td>" + packName(n) + (n === 100 ? ' <span class="cpb-tag font-sans text-[10.5px] font-semibold tracking-[.06em] uppercase bg-brand-primary text-[#1E1E1E] pt-[.14rem] pr-[.45rem] pb-[.14rem] pl-[.7rem] [clip-path:polygon(6px_0,100%_0,100%_100%,6px_100%,0_50%)] whitespace-nowrap leading-[1.4] [.cpb-opt_&]:absolute [.cpb-opt_&]:top-[8px] [.cpb-opt_&]:right-0 [.cpb-ladder_tr.hl_td:first-child_&]:ml-[8px] [.cpb-steps_li.is-key_&]:absolute [.cpb-steps_li.is-key_&]:top-[20px] [.cpb-steps_li.is-key_&]:right-0">Most ordered</span>' : "") + "</td><td>" + money(p) + "</td><td>" + money(Math.round(p / n)) + "</td></tr>";
        });
      }
      if (body) body.innerHTML = rows;
      if (table) table.hidden = !rows;
      var p100 = entry && entry[3] ? entry[3][3] : null, p1 = entry && entry[3] ? entry[3][0] : null;
      var buy = qs("[data-res-buy]", root), tr = qs("[data-res-try]", root);
      var href = entry ? "/products/" + entry[2] : null;
      if (buy) { buy.innerHTML = "<span>Choose " + lbl(size) + (p100 ? ' — <span class="m">' + money(p100) + "</span> for 100" : "") + "</span>"; buy.hidden = !href; buy.setAttribute("href", href || "#"); }
      if (tr) { tr.innerHTML = "<span>Try one" + (p1 ? ' — <span class="m">' + money(p1) + "</span>" : "") + "</span>"; tr.hidden = !href; tr.setAttribute("href", href || "#"); }
    }
    function set(sel, t) { var el = qs(sel, root); if (el) el.textContent = t; }

    function choose(pack, ev) {
      var u = uses.filter(function (x) { return x.key === cur; })[0];
      var P = window.cpBagCurrent;
      if (!P || !u) return; /* no product on this page: the link just opens the product */
      ev.preventDefault();
      var size = u.w + "x" + u.h;
      var e = rangeEntry(P.data.colour, size) || rangeEntry("natural", size);
      if (!e) return;
      var buy = qs("[data-cpb-product]");
      if (buy) buy.scrollIntoView({ behavior: "smooth", block: "start" });
      var S0 = { f: null, c: null, n: pack, qty: 1, exact: "" };
      var curRoot = P.root;
      var fIn = qs('[data-step="fabric"] input:checked', curRoot), cIn = qs('[data-step="closure"] input:checked', curRoot);
      if (fIn) S0.f = fIn.value; if (cIn) S0.c = cIn.value;
      P.go(e[2] === P.data.handle ? location.pathname : "/products/" + e[2], S0);
    }

    root.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-use]");
      if (b) { cur = b.getAttribute("data-use"); render(); return; }
      if (ev.target.closest("[data-res-buy]")) return choose(100, ev);
      if (ev.target.closest("[data-res-try]")) return choose(1, ev);
    });
    document.addEventListener("cp:bag-change", render);
    render();
  }

  /* theme editor: re-initialise a section when it is re-rendered */
  document.addEventListener("shopify:section:load", function (e) {
    qsa("[data-cpb-product]", e.target).forEach(function (r) { initProduct(r); });
    qsa("[data-cpb-finder]", e.target).forEach(initFinder);
  });

  function boot() {
    qsa("[data-cpb-product]").forEach(function (r) { initProduct(r); });
    qsa("[data-cpb-finder]").forEach(initFinder);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
